module.exports = __webpack_public_path__ + "media/images/flags/1x1/mac-3fa8d1cbbf7994b353bbc776c0ac81be.svg";